'use strict';
import React from 'react';
import * as ReactRedux from 'react-redux';

class BreadcrumbComponent extends React.Component {
    renderBreadCrumbs() {
        var self = this;
        let pageTemplate = [];
        pageTemplate.push(
            <p key={998}>
                <a href='/'>Home</a>
            </p>
        );
        pageTemplate.push(<i key={999} className='fa fa-angle-right'></i>);

        if (self.props.categories) {
            let mainParentID = '';
            let categoryToShow = [];
            let gotMainParentCategoryID = false;
            self.props.categories.sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));

            self.props.categories.forEach(function(data, index) {
                //Main Parent
                if (data.parentCategoryID === null && gotMainParentCategoryID === false) {
                    mainParentID = data.id;
                    categoryToShow.push(data);
                    gotMainParentCategoryID = true;
                }
            });
            function checkParentCategory(ID) {
                self.props.categories.forEach(function(data, index) {
                    //Child
                    if (data.parentCategoryID === ID) {
                        categoryToShow.push(data);
                        checkParentCategory(data.id);
                    }
                });
            }
            //checkParentCategory(mainParentID);

            categoryToShow.forEach(function(data, index) {
                if (categoryToShow.length - 1 == index) {
                    pageTemplate.push(
                        <p key={index + data.id} className='active'>
                            <a href={'/search?categories=' + data.id}>{data.name}</a>
                        </p>
                    );
                } else {
                    pageTemplate.push(
                        <p key={index + data.name} className=''>
                            <a href={'/search?categories=' + data.id}>{data.name}</a>
                        </p>
                    );
                    pageTemplate.push(<i key={index + data.id} className='fa fa-angle-right'></i>);
                }
            });
        }

        return pageTemplate;
    }

    render() {
        return <div className='h-parent-child-txt full-width'>{this.renderBreadCrumbs()}</div>;
    }
}

export default BreadcrumbComponent;
